import request from '@/utils/request' //引入封装好的 axios 请求

export function selectAllUser() { //登录接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/user/allUserList',
    method: 'get',
  })
}

export function updateuser(user) { //修改接口

  return request({ //使用封装好的 axios 进行网络请求
    url: '/user/UpdateUserInfo',
    method: 'post',
    data: {
      userId: user.userId,
      userName: user.userName,
      userPassword: user.userPassword,
      userSex: user.userSex,
      userPhone: user.userPhone,
      userStatus:user.userStatus
    },
  })
}

export function insertUser(user) { //添加接口

  return request({ //使用封装好的 axios 进行网络请求
    url: '/user/AddUser',
    method: 'post',
    data: {
      //用户名
      userName: user.userName,
      //密码
      userPassword: user.userPassword,
      //性别
      userSex: user.userSex,
      //电话
      userPhone: user.userPhone
    },
  })
}

export function deleteuser(jo) { //删除接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/user/DeleteUserInfo',
    method: 'post',
    contentType: "application/json;charset=UTF-8",
    data: jo
  })
}